export default ({color, size}) =>
  <svg xmlns="http://www.w3.org/2000/svg" t="1753429927414" className="icon"
       viewBox="0 0 1024 1024" version="1.1" p-id="1514" width={size} height={size}>
    <path
      d="M0 877.714286h1024v146.285714H0zM585.142857 804.571429H438.857143V365.714286H146.285714l365.714286-365.714286 365.714286 365.714286H585.142857z"
      p-id="1515" fill={color} />
  </svg>
;
